import { EQueryParameters as ELandingType } from '../../repositories/feed-page/v2/mobile-site/get-recommendations';
import { IAppState } from '../../types/redux';
import { selectLandingType } from './landingType';

export function selectIsIndexLandingType(state: IAppState): boolean {
  const type = selectLandingType(state);

  return type === ELandingType.MainPage;
}
